var map = {
	"./decidim/avatar-multiuser.png": 56289,
	"./decidim/brands/google.svg": 14532,
	"./decidim/cc-badge.png": 15368,
	"./decidim/decidim-logo.svg": 77060,
	"./decidim/default-avatar.svg": 76486,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 88091,
	"./decidim/icons.svg": 4969,
	"./decidim/pattern.png": 57663,
	"./decidim/placeholder.jpg": 82870,
	"./decidim/vendor/leaflet/layers-2x.png": 48982,
	"./decidim/vendor/leaflet/layers.png": 46345,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 13987,
	"./decidim/vendor/leaflet/marker-icon.png": 73703,
	"./decidim/vendor/leaflet/marker-shadow.png": 2965,
	"./decidim/vendor/social-share-button/delicious.svg": 52943,
	"./decidim/vendor/social-share-button/douban.svg": 38254,
	"./decidim/vendor/social-share-button/email.svg": 63791,
	"./decidim/vendor/social-share-button/facebook.svg": 87467,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 23953,
	"./decidim/vendor/social-share-button/google_plus.svg": 67584,
	"./decidim/vendor/social-share-button/hacker_news.svg": 85791,
	"./decidim/vendor/social-share-button/linkedin.svg": 3087,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 55781,
	"./decidim/vendor/social-share-button/pinterest.svg": 61416,
	"./decidim/vendor/social-share-button/qq.svg": 68104,
	"./decidim/vendor/social-share-button/reddit.svg": 42847,
	"./decidim/vendor/social-share-button/telegram.svg": 69444,
	"./decidim/vendor/social-share-button/tumblr.svg": 97001,
	"./decidim/vendor/social-share-button/twitter.svg": 54811,
	"./decidim/vendor/social-share-button/vkontakte.svg": 95630,
	"./decidim/vendor/social-share-button/wechat.svg": 14045,
	"./decidim/vendor/social-share-button/weibo.svg": 76699,
	"./decidim/vendor/social-share-button/whatsapp.svg": 82411,
	"./decidim/vendor/social-share-button/x.svg": 59307,
	"./decidim/vendor/social-share-button/xing.svg": 91243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78674;